import { useFormContext } from 'react-hook-form';
import React from 'react';

import { COLORS } from 'Components/foundation';
import SDivider from 'Components/structural/SDivider/SDivider';
import UIcon from 'Components/unit/UIcon/UIcon';
import { useTypedSelector } from 'Libs/redux/utils';
import { CampaignFormValues } from 'Pages/Activity/Campaign/saveCampaign.hook';
import { withCampaignHoc } from 'Pages/Activity/Campaign/hoc/withCampaign';

import styles from './SchedulePanel.style';
import { ScheduleDaysForm } from './components/ScheduleDaysForm';
import { ScheduleLaunchDateForm } from './components/ScheduleLaunchDateForm';
import { ScheduleModeForm } from './components/ScheduleModeForm';
import { ScheduleTypeForm } from './components/ScheduleTypeForm';

export const SchedulePanel = withCampaignHoc(({ campaign }) => {
  const { locked } = useTypedSelector((state) => state.entities.activity.edition);
  const overlayStyle = locked ? styles.locked : styles.unlocked;

  const { watch, setValue } = useFormContext<CampaignFormValues>();

  const schedulingModeLocked = campaign.status === 'live' && watch('mode') === 'random';

  const handleScheduleModeChange = (mode: 'manual' | 'random') => {
    setValue('mode', mode);

    // Random -> manual
    if (mode === 'manual') {
      const contents = [watch('contents') || []];

      setValue('orderedSessions', contents);
      setValue('nbSessions', undefined);
      setValue('contents', undefined);
    } else {
      // Manual -> random
      const contents = (watch('orderedSessions') || []).flat();

      setValue('contents', contents);
      setValue('nbSessions', Object.keys(watch('orderedSessions') || {})?.length);
      setValue('orderedSessions', undefined);
    }
  };

  return (
    <div style={styles.wrapper}>
      <ScheduleModeForm
        currentMode={watch('mode')}
        editable={!schedulingModeLocked}
        onChange={handleScheduleModeChange}
      />
      <SDivider style={styles.divider} />
      <ScheduleTypeForm
        currentType={watch('type')}
        extraDays={watch('extraDays')}
        onExtraDaysChange={(value) => setValue('extraDays', value)}
        onTypeChange={(value) => setValue('type', value)}
      />
      <SDivider style={styles.divider} />
      <ScheduleLaunchDateForm
        launchDate={watch('launchDate') || ''}
        disabled={locked}
        onDateChange={(value) => setValue('launchDate', value)}
      />
      <SDivider style={styles.divider} />
      <ScheduleDaysForm
        disabledDays={watch('disabledDates') || []}
        enabledDays={watch('enabledWeekDays') || []}
        onDisabledDaysChange={(value) => setValue('disabledDates', value)}
        onEnabledDaysChange={(value) => setValue('enabledWeekDays', value)}
      />
      <SDivider style={styles.divider} />
      <div style={overlayStyle}>
        <UIcon name="lock" size={64} color={COLORS.TEXT.SECONDARY_DEFAULT} />
      </div>
    </div>
  );
});
